import { jsx as o, jsxs as q, Fragment as T } from "react/jsx-runtime";
import k, { useState as A, useId as v, useEffect as F, cloneElement as w } from "react";
import { c as p } from "../clsx-OuTLNxxd.js";
import { A as R, E as U } from "../index-CeQ14xPc.js";
import '../Accordion.css';const j = "320px", L = "600px", O = "1025px", D = "_header_d2qpo_33", G = "_splitHeader_d2qpo_37", J = "_iconSlot_d2qpo_43", K = "_heading_d2qpo_50", Q = "_toggle_d2qpo_57", X = "_triggerElement_d2qpo_66", Y = "_indicator_d2qpo_72", Z = "_trigger_d2qpo_66", M = "_contentElement_d2qpo_112", V = "_content_d2qpo_112", C = "_primary_d2qpo_132", N = "_secondary_d2qpo_135", ee = "_item_d2qpo_141", te = "_dense_d2qpo_141", ne = "_nav_d2qpo_234", oe = "_link_d2qpo_239", ie = "_headingText_d2qpo_271", ce = "_linkLabel_d2qpo_272", de = "_linkList_d2qpo_297", t = {
  mobile: j,
  "mobile-wide": "480px",
  tablet: L,
  "tablet-wide": "800px",
  desktop: O,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  header: D,
  splitHeader: G,
  iconSlot: J,
  heading: K,
  toggle: Q,
  triggerElement: X,
  indicator: Y,
  trigger: Z,
  contentElement: M,
  content: V,
  primary: C,
  secondary: N,
  item: ee,
  dense: te,
  nav: ne,
  link: oe,
  headingText: ie,
  linkLabel: ce,
  linkList: de
}, re = (l) => {
  if (typeof requestAnimationFrame != "function")
    return l(), () => {
    };
  let x = 0;
  const c = requestAnimationFrame(() => {
    x = requestAnimationFrame(l);
  });
  return () => {
    cancelAnimationFrame(c), cancelAnimationFrame(x);
  };
}, le = ({
  animationDurationMs: l = 0,
  indicatorSize: x = "s",
  isOpen: c,
  isPanelLandmark: e = !0,
  onChange: g,
  stroke: z = "bold"
}) => {
  const [n, y] = A(c), s = l > 0, [m, _] = A(c), [u, a] = A(!!c), b = v(), h = v(), H = () => {
    g == null || g(!n), y(!n);
  };
  F(() => {
    c !== n && y(c);
  }, [c]), F(() => {
    if (!s) return;
    if (n)
      return _(!0), re(() => a(!0));
    a(!1);
    const d = setTimeout(() => _(!1), l);
    return () => clearTimeout(d);
  }, [n, s, l]);
  const f = {
    "aria-controls": h,
    // The watermark travels with the hook, not just with `Accordion.Item`. A caller that drives the
    // disclosure headlessly renders cxy's behaviour on markup of its own — the footer nav does — and
    // without this it is indistinguishable in the DOM from a hand-rolled toggle, which is the one
    // question `data-cxy-name` exists to answer.
    "data-cxy-name": "accordion",
    "aria-expanded": n,
    "data-state": n ? "open" : "closed",
    id: b,
    onClick: H
  }, i = {
    "aria-labelledby": b,
    className: t.contentElement,
    hidden: s ? !m : !n,
    id: h,
    ...e ? { role: "region" } : {},
    ...s ? { "data-animated": "" } : {},
    ...s && u ? { "data-enter": "" } : {}
  };
  return {
    headingProps: f,
    sectionProps: i,
    triggerClass: t.triggerElement,
    Indicator: () => z === "bold" ? /* @__PURE__ */ o(R, { className: t.indicator, size: x }) : /* @__PURE__ */ o(U, { className: t.indicator, size: x })
  };
}, ye = 300, xe = ({
  animationDurationMs: l = 0,
  chevronStroke: x = "bold",
  children: c,
  classNames: e,
  heading: g,
  headingAs: z = "h3",
  icon: n,
  indicator: y,
  indicatorSize: s = "s",
  isDense: m = !1,
  isOpen: _ = !1,
  isPanelLandmark: u = !0,
  links: a,
  onChange: b,
  onLinkClick: h,
  testId: H,
  toggleLabel: f,
  trackingAttribute: i,
  variant: d
}) => {
  const { Indicator: r, headingProps: W, sectionProps: E, triggerClass: B } = le({
    animationDurationMs: l,
    isOpen: _,
    isPanelLandmark: u,
    onChange: b,
    indicatorSize: s,
    stroke: x
  }), I = {
    ...W,
    ...i ? { "data-analytics": i } : {},
    ...H ? { "data-testid": H } : {},
    type: "button"
  }, { id: P, ...$ } = I;
  return /* @__PURE__ */ q(
    "div",
    {
      className: p(
        t.item,
        { [t.dense]: m },
        d && d !== "bare" && t[d],
        e == null ? void 0 : e.wrapper
      ),
      "data-cxy-name": "accordion",
      children: [
        /* @__PURE__ */ o(z, { className: p(t.header, { [t.splitHeader]: f }, e == null ? void 0 : e.header), children: f ? /* @__PURE__ */ q(T, { children: [
          /* @__PURE__ */ q("span", { className: p(t.heading, e == null ? void 0 : e.heading), id: P, children: [
            n !== void 0 && /* @__PURE__ */ o("span", { className: t.iconSlot, children: n }),
            g
          ] }),
          /* @__PURE__ */ o(
            "button",
            {
              "aria-label": f,
              className: p(B, t.toggle, e == null ? void 0 : e.button),
              ...$,
              children: y ?? /* @__PURE__ */ o(r, {})
            }
          )
        ] }) : /* @__PURE__ */ q("button", { className: p(B, t.trigger, e == null ? void 0 : e.button), ...I, children: [
          n === void 0 ? g : /* @__PURE__ */ q(T, { children: [
            /* @__PURE__ */ o("span", { className: t.iconSlot, children: n }),
            /* @__PURE__ */ o("span", { className: p(t.headingText, e == null ? void 0 : e.heading), children: g })
          ] }),
          y ?? /* @__PURE__ */ o(r, {})
        ] }) }),
        /* @__PURE__ */ o(
          "div",
          {
            ...E,
            className: p(t.content, e == null ? void 0 : e.content),
            style: { "--cxy-accordion-duration": `${l}ms` },
            children: a ? /* @__PURE__ */ o("ul", { className: t.linkList, children: a.map((S) => /* @__PURE__ */ o("li", { children: /* @__PURE__ */ q("a", { className: t.link, href: S.href, onClick: () => h == null ? void 0 : h(S), children: [
              /* @__PURE__ */ o("span", { className: t.iconSlot, children: S.icon }),
              /* @__PURE__ */ o("span", { className: t.linkLabel, children: S.label })
            ] }) }, `${S.href}-${S.label}`)) }) : c
          }
        )
      ]
    }
  );
}, se = ({
  chevronStroke: l = "bold",
  children: x,
  defaultOpen: c,
  indicatorSize: e = "s",
  isDense: g = !1,
  name: z,
  onValueChange: n,
  type: y = "single",
  value: s,
  variant: m = "primary"
}) => {
  const _ = y === "multiple", u = s !== void 0, a = k.Children.toArray(x), b = c ? a.map(() => !0) : a.map((i) => !!i.props.isOpen), [h, H] = A(b), f = (i, d) => {
    let r = [];
    _ ? (r = [...h], r[d] = i) : (r = a.map(() => !1), i === !0 && (r[d] = !0)), H(r);
  };
  return /* @__PURE__ */ o(
    "div",
    {
      className: p(t.accordion, m !== "bare" && t[m]),
      "data-cxy-name": "accordion",
      "data-testid": "accordion-component",
      children: x && a.map(
        (i, d) => (
          // Cloned rather than rebuilt from named props: every prop the item declares reaches it,
          // so adding one to `AccordionItemProps` does not also require adding it here.
          w(i, {
            chevronStroke: l,
            indicatorSize: e,
            isDense: g,
            variant: m,
            isOpen: u ? i.props.value === s : h[d],
            key: `${z}-item-${d}`,
            onChange: (r) => {
              var W, E;
              (E = (W = i.props).onChange) == null || E.call(W, r), u ? n == null || n(r ? i.props.value ?? null : null) : f(r, d);
            }
          })
        )
      )
    }
  );
};
se.Item = xe;
export {
  ye as ACCORDION_FADE_DURATION_MS,
  se as Accordion,
  le as useToggle
};
